import { CalendarIcon, ClockIcon } from "@heroicons/react/24/outline";
// import Icon
export interface INameStageCard {
  name: string;
  role?: string;
  stage?: string;
  date?: string;
  coiNumber?: string;
  containerClass?: string;
  stageColor?: string;
}

export default function NameStageCard({
  name,
  role,
  stage,
  date,
  coiNumber,
  containerClass,
  stageColor = "bg-slate-300",
}: INameStageCard) {
  function getName(name: string | "") {
    const arrName = name.split(" ");
    let res = "";
    for (let i = 0; i < arrName.length; i++) {
      res += arrName[i][0];
    }
    return res;
  }
  return (
    <div className={`${containerClass} flex flex-col mb-5 text-xs`}>
      <span className="flex gap-2">
        <span
          className={`rounded-full min-w-8  bg-stone-200 p-1 size-8 flex justify-center items-center font-bold`}
        >
          {getName(String(name))}
        </span>
        <span className="flex flex-col min-w-[48%]">
          <span className="font-extrabold text-xs">{name}</span>
          <span className="text-xs font-semibold text-darkGray"> {role}</span>
        </span>
        <span
          className={`h-8 rounded-full brightness-90 ${stageColor} flex items-center justify-center min-w-20`}
        >
          <span
            className={`rounded-full s-2 brightness-50 ${stageColor} p-1 mr-1`}
          />
          <span className="text-xs font-semibold">{stage}</span>
        </span>
      </span>
      <span className="flex gap-6  py-3">
        <span className="flex  gap-1">
          <ClockIcon className="size-4 text-black" />
          <p className="text-xs font-extrabold text-darkGray">{date}</p>
        </span>
        <span className="flex font-semibold text-xs gap-1">
          <CalendarIcon className="size-4 text-black" />
          <p className="text-xs font-extrabold text-darkGray">{coiNumber}</p>
        </span>
      </span>
      <span className="w-[100%] border-t border-dashed text-body opacity-40" />
    </div>
  );
}
